import { Heading, Layout, Paragraph } from '@vwfs-bronson/bronson-react';
import { Form, Formik } from 'formik';
import React, { FunctionComponent, memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { formAutocomplete } from '../../config';
import { createFormInputs } from './formInputs';
import { summaryConsentFormSliceSelectors } from './summaryConsentForm.slice';
import { summaryConsentFormSchema } from './summaryConsentForm.validator';

// eslint-disable-next-line react/display-name
export const SummaryConsentForm: FunctionComponent<{ disabled?: boolean }> = memo(({ disabled }) => {
  const initialValues = useSelector(summaryConsentFormSliceSelectors.summaryConsentValues);
  const { t } = useTranslation();
  const inputs = useMemo(() => createFormInputs(disabled || false), [disabled]);

  return (
    <Formik
      validationSchema={summaryConsentFormSchema()}
      initialValues={initialValues}
      onSubmit={(_: any, { setSubmitting }: any) => {
        setSubmitting(false);
      }}
      validateOnMount
      validateOnChange={false}
      validateOnBlur
    >
      <>
        <Form autoComplete={formAutocomplete} className="u-text-left">
          <Layout>
            <Layout.Item default="1/1">
              <Heading level={3} className="u-text-base u-mb-none u-mt-small">
                {t('consents:heading')}
              </Heading>
            </Layout.Item>

            <Layout.Item>
              <Paragraph> {t('consents:paragraph')} </Paragraph>
            </Layout.Item>
            <Layout.Item default="1/1">
              <b> {inputs.marketingVWFS()} </b>
            </Layout.Item>
            <Layout.Item>
              <Paragraph> {t('consents:stayInformedParagraph')} </Paragraph>
            </Layout.Item>

            <Layout.Item default="1/5" m="1/4" s="1/1">
              {inputs.emailVWFS()}
            </Layout.Item>
            <Layout.Item default="1/5" m="1/4" s="1/1">
              {inputs.mobilePhoneVWFS()}
            </Layout.Item>
            <Layout.Item default="1/5" m="1/4" s="1/1">
              {inputs.landlineVWFS()}
            </Layout.Item>
            <Layout.Item default="1/5" m="1/4" s="1/1">
              {inputs.postVWFS()}
            </Layout.Item>

            <Layout.Item default="1/1" className="u-mt u-mt-large@s">
              <b> {inputs.marketingBP()} </b>
            </Layout.Item>
            <Layout.Item>
              <Paragraph> {t('consents:stayInformedParagraph')} </Paragraph>
            </Layout.Item>

            <Layout.Item default="1/5" m="1/4" s="1/1">
              {inputs.emailBP()}
            </Layout.Item>
            <Layout.Item default="1/5" m="1/4" s="1/1">
              {inputs.mobilePhoneBP()}
            </Layout.Item>
            <Layout.Item default="1/5" m="1/4" s="1/1">
              {inputs.landlineBP()}
            </Layout.Item>
            <Layout.Item default="1/5" m="1/4" s="1/1">
              {inputs.postBP()}
            </Layout.Item>

            <Layout.Item>
              <Paragraph dangerouslySetInnerHTML={{ __html: t('consents:furtherDetailsParagraph') }} />
            </Layout.Item>
          </Layout>
        </Form>
      </>
    </Formik>
  );
});
